var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "details-view" }, [
    _c("div", { staticClass: "main-content hrSetting" }, [
      _c(
        "div",
        { staticClass: "section form-column" },
        [
          _c(
            "el-form",
            { staticStyle: { "flex-direction": "row" } },
            [
              _c(
                "el-form-item",
                { staticStyle: { "margin-bottom": "15px!important" } },
                [
                  !_vm.isEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.editHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                      )
                    : _vm._e(),
                  _vm.isEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.saveHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.refreshHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Refresh")))]
                  )
                ],
                1
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "14px",
                    "margin-left": "20px",
                    "font-weight": "bold"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("PillReport.SetJudgmentCriteria")))]
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.selectedList,
                        callback: function($$v) {
                          _vm.selectedList = $$v
                        },
                        expression: "selectedList"
                      }
                    },
                    _vm._l(_vm.settings, function(item, index) {
                      return _c(
                        "el-checkbox",
                        {
                          key: index,
                          staticStyle: {
                            display: "block",
                            width: "180px",
                            "padding-top": "5px",
                            "margin-left": "60px"
                          },
                          attrs: {
                            label: item.seqNo,
                            disabled: _vm.disabled(item)
                          }
                        },
                        [_vm._v(_vm._s(item.fieldLabel))]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }